import * as policyRimBusiness from '../../../../business/logic/policy-business-logic-rim';

import BelfiusCurrencyText from '../../../custom/belfius-currency-text';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { Ii18n } from '../../../../store/utils/contracts/i18n.interface';
import * as React from 'react';
import { RimLine } from '../../../../store/details/rim/types';
import { RimSectionTC } from '../../../../business/models/typecode.enums';
import { TypeCodeTranslation } from '../../../../business/models/shared.model';
import { getTypeCodeTranslation } from '../../../../store/utils/typecodes/typecode-translations';
import styles from './rim-lines.module.css';
import { removeRimLine } from '../../../../store/details/rim/actions';

interface Props {
  readonly rimLines: RimLine[];
  readonly rimSectionValues: TypeCodeTranslation[];
  readonly vatTrasholdTCValues: TypeCodeTranslation[];
  readonly vatPercentageValues: TypeCodeTranslation[];
  readonly rimItemValues: TypeCodeTranslation[];
  readonly currentLanguage: string;
  readonly localization: Ii18n;
  readonly locked: boolean;
  readonly conditions: string;
  readonly removeRimLine: typeof removeRimLine;
}

export class RimLinesOverview extends React.Component<Props> {
  render() {
    const getRimSelectionTranslation = (rimSectionTC: string, rimItemTC: string) => {
      if (rimSectionTC === RimSectionTC.Gen) {
        return getTypeCodeTranslation(this.props.rimItemValues, this.props.currentLanguage, rimItemTC);
      } else {
        return `${getTypeCodeTranslation(this.props.rimSectionValues, this.props.currentLanguage, rimSectionTC)} (${getTypeCodeTranslation(this.props.rimItemValues, this.props.currentLanguage, rimItemTC)})`;
      }
    };

    const vatOverview = (vatThresholdTC: string, vatPercentageTC: string) => {
      if (vatPercentageTC) {
        return (
          <span className={styles.tableText}>
            {getTypeCodeTranslation(this.props.vatTrasholdTCValues, this.props.currentLanguage, vatThresholdTC)} {getTypeCodeTranslation(this.props.vatPercentageValues, this.props.currentLanguage, vatPercentageTC)}% {this.props.localization.get('shared.vat')}
          </span>
        );
      } else {
        return (
          <span className={styles.tableText}>
            {getTypeCodeTranslation(this.props.vatTrasholdTCValues, this.props.currentLanguage, vatThresholdTC)}
          </span>
        );
      }
    };

    const rimLines = this.props.rimLines.filter(x => !x.deleted).map(r => {
      return (
        <div className={styles.tableRow} key={r.sequence}>
          <div className={`${styles.tableText} ${styles.tableRimSection}`}>
            <span>{getRimSelectionTranslation(r.rimSectionTC, r.rimItemTC)}</span>
          </div>
          <div className={`${styles.tableText} ${styles.tableDescription}`}>
            <span>{r.description}</span>
          </div>
          <div className={`${styles.tableVat}`}>
            <span>{vatOverview(r.vatThresholdTC, r.vatPercentageTC)}</span>
          </div>
          <div className={`${styles.tableEuro} ${styles.alignCenter}`}>
            <span>€</span>
          </div>
          <div className={`${styles.tableCurrency} ${styles.alignRight}`}>
            <BelfiusCurrencyText className={styles.alignRight}
              value={r.amount} />
          </div>
          <div className={`${styles.tableButton} ${styles.alignCenter}`}>
            <div className={styles.removebutton}>
              <img alt="" src={require('../../../../assets/images/remove_33x33.png')} onClick={() => {
                if (!this.props.locked) {
                  this.props.removeRimLine(r.sequence);
                }
              }} />
            </div>
          </div>
        </div>
      );
    });

    const rimLinesTable = () => {
      return (
        <div>
          <div className={`${styles.tableRow} ${styles.borderBottom}`}>
            <div className={`${styles.tableText} ${styles.tableRimSection}`} />
            <div className={`${styles.tableText} ${styles.tableDescription}`} />
            <div className={styles.tableVat} />
            <div className={`${styles.tableHeaderCurrency} ${styles.alignCenter}`}>
              <span><b>{this.props.localization.get('details.rim.rimLines.settlementProposal')}</b></span>
            </div>
            <div className={`${styles.tableButton}`} />
          </div>
          {rimLines}
          <div className={styles.tableRow}>
            <div className={`${styles.tableText} ${styles.tableTotalText}`}>
              <span>{this.props.localization.get('details.rim.rimLines.totalAmount100')}</span>
            </div>
            <div className={styles.tableEuro} />
            <div className={styles.tableCurrency} />
            <div className={`${styles.tableEuro} ${styles.alignCenter}`}>
              <span>€</span>
            </div>
            <div className={`${styles.tableCurrency} ${styles.alignRight}`}>
              <span><b><BelfiusCurrencyText
                        value={policyRimBusiness.getRimLinesSum(this.props.rimLines)}
                      />
                    </b>
              </span>
            </div>
            <div className={styles.tableButton} />
          </div>
        </div>
      );
    };

    const rimLinesCocoon = this.props.rimLines.filter(x => !x.deleted).map(r => {
      return (
        <div className={styles.tableRow} key={r.sequence}>
          <div className={`${styles.tableText} ${styles.tableRimSection}`}>
            <span>{getRimSelectionTranslation(r.rimSectionTC, r.rimItemTC)}</span>
          </div>
          <div className={`${styles.tableText} ${styles.tableDescription}`}>
            <span>{r.description}</span>
          </div>
          <div className={`${styles.tableVat}`}>
            <span>{vatOverview(r.vatThresholdTC, r.vatPercentageTC)}</span>
          </div>
          <div className={`${styles.tableSpecial} ${styles.alignCenter}`}>
            <span>{r.invoicePresent === true ? <CheckBoxIcon /> : ''}</span>
          </div>
          <div className={`${styles.tableEuro} ${styles.alignCenter}`}>
            <span>€</span>
          </div>
          <div className={`${styles.tableCurrency} ${styles.alignRight}`}>
            <BelfiusCurrencyText className={styles.alignRight}
              value={policyRimBusiness.getRimLineAmount100(r.vatThresholdTC, r.amount, r.vatPercentageTC)} />
          </div>
          <div className={`${styles.tableEuro} ${styles.alignCenter}`}>
            <span>€</span>
          </div>
          <div className={`${styles.tableCurrency} ${styles.alignRight}`}>
            <BelfiusCurrencyText className={styles.alignRight}
              value={+r.amount80 > 0 ? r.amount80 : r.amount} />
          </div>
          <div className={`${styles.tableButton} ${styles.alignCenter}`}>
            <div className={styles.removebutton}>
              <img alt="" src={require('../../../../assets/images/remove_33x33.png')} onClick={() => {
                if (!this.props.locked) {
                  this.props.removeRimLine(r.sequence);
                }
              }} />
            </div>
          </div>
        </div>
      );
    });

    const rimLinesCocoonTable = () => {
      return (
        <div>
          <div className={`${styles.tableRow} ${styles.borderBottom}`}>
            <div className={`${styles.tableText} ${styles.tableRimSection}`} />
            <div className={`${styles.tableText} ${styles.tableDescription}`} />
            <div className={styles.tableVat} />
            <div className={`${styles.tableSpecial} ${styles.alignCenter}`}>
              <span><b>{this.props.localization.get('details.rim.rimLines.offer')}</b></span>
            </div>
            <div className={`${styles.tableHeaderCurrency} ${styles.alignCenter}`}>
              <span><b>{this.props.localization.get('details.rim.rimLines.compensation100')}</b></span>
            </div>
            <div className={`${styles.tableHeaderCurrency} ${styles.alignCenter}`}>
              <span><b>{this.props.localization.get('details.rim.rimLines.settlementProposal')}</b></span>
            </div>
            <div className={`${styles.tableButton}`} />
          </div>
          {rimLinesCocoon}
          <div className={styles.tableRow}>
            <div className={`${styles.tableText} ${styles.tableTotalText}`}>
              <span>{this.props.localization.get('details.rim.rimLines.totalAmount')}</span>
            </div>
            <div className={styles.tableEuro} />
            <div className={styles.tableCurrency} />
            <div className={`${styles.tableEuro} ${styles.alignCenter}`}>
              <span>€</span>
            </div>
            <div className={`${styles.tableCurrency} ${styles.alignRight}`}>
              <span><b>
                <BelfiusCurrencyText
                value={policyRimBusiness.getRimLinesSum(this.props.rimLines)} />
                </b></span>
            </div>
            <div className={styles.tableButton} />
          </div>
          <div className={styles.tableRow}>
            <div className={`${styles.tableText} ${styles.tableTotalText}`}>
              <span>{this.props.localization.get('details.rim.rimLines.totalAmount100')}</span>
            </div>
            <div className={`${styles.tableEuro} ${styles.alignCenter}`}>
              <span>€</span>
            </div>
            <div className={`${styles.tableCurrency} ${styles.alignRight}`}>
              <span><b>
                <BelfiusCurrencyText
                value={policyRimBusiness.getRimLinesSum100(this.props.rimLines)} />
                </b></span>
            </div>
            <div className={styles.tableEuro} />
            <div className={styles.tableCurrency} />
            <div className={styles.tableButton} />
          </div>
        </div>
      );
    };

    return (
      <div className={styles.rimLinesOverview}>
        {policyRimBusiness.isCocoon(this.props.conditions) ? rimLinesCocoonTable() : rimLinesTable()}
        {policyRimBusiness.showFranchiseMissingWarning(this.props.rimLines) && <div className={styles.row}>
          <span className={styles.rimLinesWarning}>{this.props.localization.get('details.rim.rimLines.franchise.or.indirect.losses')}</span>
        </div>}
      </div>
    );
  }
}
